import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ListIcon from "@mui/icons-material/List";
import { Grid2, IconButton } from "@mui/material";
import { MillAdjustmentByShift } from "../models/MillAdjustmentByShift";
type Props = {
	data: MillAdjustmentByShift;
	editData: (data: MillAdjustmentByShift) => void;
	deleteData: (data: MillAdjustmentByShift) => void;
	showContextMenu: () => void;
};
export const GridButtons = ({
	data,
	editData,
	deleteData,
	showContextMenu,
}: Props) => {
	return (
		<Grid2
			container
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				opacity: 0,
				transition: "opacity 0.1s ease-in-out",
			}}
			className={`buttons`}
		>
			<Grid2
				size={{ md: 12, xs: 12 }}
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<IconButton
					style={{ cursor: "pointer" }}
					title="Edit"
					onClick={() => editData(data)}
				>
					<EditIcon fontSize="inherit" color="primary" />
				</IconButton>
				<IconButton
					style={{ cursor: "pointer" }}
					title="Delete"
					onClick={() => deleteData(data)}
				>
					<DeleteIcon fontSize="inherit" color="secondary" />
				</IconButton>
				<IconButton
					title="Options"
					style={{ cursor: "pointer" }}
					onClick={showContextMenu}
				>
					<ListIcon fontSize="inherit" color="primary" />
				</IconButton>
			</Grid2>
		</Grid2>
	);
};
